import { USER_ROLE } from '@/constant/user'
const { INSPECTOR, ADMIN, STANDARD, SUPPLIER } = USER_ROLE

export function isInspectorRole(user) {
  const userRole = user?.subscription?.role_access?.role

  return userRole === INSPECTOR
}

export function IsAdminRole(user) {
  const userRole = user?.subscription?.role_access?.role

  return userRole === ADMIN
}

export function IsStandardRole(user) {
  const userRole = user?.subscription?.role_access?.role

  return userRole === STANDARD
}

export function IsSupplierRole(user) {
  const userRole = user?.subscription?.role_access?.role

  return userRole === SUPPLIER
}
